/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  etapas_caso: [],
  codigo_grupo: 0,
  meta: ['CÓDIGO', 'FASE', 'ETAPA', 'ESTADO', 'USUARIO', 'FECHA REGISTRO', 'REQUIERE APROBACIÓN', 'ACCIONES']
}
